import { FC } from "react";
import AnswerCell from "./AnswerCell";

interface Answer {
  intValue?: number | null;
  textValue?: string | null;
}

interface QuestionRowProps {
  questionKey: string;
  questionText?: string | null;
  answers?: Answer[] | null;
}

const QuestionRow: FC<QuestionRowProps> = ({
  questionKey,
  questionText,
  answers,
}) => {
  return (
    <tr key={questionKey} className="hover:bg-gray-50 transition-colors">
      <td className="p-4 text-left font-normal border-0 border-b border-solid border-gray-200">
        <span className="text-sm opacity-70">{questionText}</span>
      </td>
      <td className="p-4 text-right border-0 border-b border-solid border-gray-200">
        <AnswerCell answers={answers} />
      </td>
    </tr>
  );
};

export default QuestionRow;
